import { Component, registerComponent } from 'js/component.js';

const componentName = 'plex-footer';
const breakpointPx = 1024;

class PlexFooter extends Component {

    initialized = false;

    setup() {
        // Elements
        this.elements = {
            element: document.querySelector(`plex-footer.${componentName}`),
            copyrightText: document.querySelector(`.${componentName}__copyright-text`),
            copyrightTextMobile: document.querySelector(`.${componentName}__copyright-text-mobile`),
            raLinkListTitle: document.querySelectorAll(`${componentName} .ra-link-list__title`),
        };

        this.elements.copyrightText.textContent = this.elements.copyrightText.textContent.replace('YYYY', new Date().getFullYear());
        this.elements.copyrightTextMobile.textContent = this.elements.copyrightTextMobile.textContent.replace('YYYY', new Date().getFullYear());
    }

    addHeaderListeners() {
        const activeClass = `${componentName}--active`;
        this.elements.raLinkListTitle.forEach((el) => {
            el.addEventListener('click', (ev) => {
                if (window.innerWidth < breakpointPx) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    el.parentElement?.classList.toggle(activeClass);
                    this.slideToggle(ev);
                }
            });
        });
    }

    slideToggle(ev) {
        ev.preventDefault();
        const titleEl = ev.currentTarget;
        const listEl = titleEl.parentElement.querySelector('.ra-link-list__list');

        if (!listEl.classList.contains('active')) {
            listEl.classList.add('active');
            listEl.style.height = 'auto';

            const height = `${listEl.clientHeight}px`;
            listEl.style.height = '0px';

            setTimeout(() => {
                listEl.style.height = height;
            });
        } else {
            listEl.style.height = '0px';

            listEl.addEventListener('transitionend', () => {
                listEl.classList.remove('active');
            }, { once: true });
        }
    }

    // ==========
    // Editable Initial Editing
    // ==========
    editableInitialEditing = () => {
        if(!window.location.href.includes('config-pages/footer-config.html') && (document.querySelector('[data-path*="config-pages/footer-config"]') !== null)) {
            document.querySelectorAll('[data-path*="config-pages/footer-config"]').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('.plex-footer .authoring-component-label').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('.plex-footer .col-mobile .newpar.new.section').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('.plex-footer .col-mobile [data-emptytext="Link List"]').forEach((el) => {
                el.remove();
            });
        }
    };

    /**
     * Initialize Component
     */
    init() {
        const plexFooterElement = document.querySelector(`plex-footer.${componentName}`);
        // Ensure this element is only initialized once
        if (plexFooterElement.dataset.initialized === 'true') {
            console.warn('Footer component already initialized for this element');
            return;
        }

        plexFooterElement.dataset.initialized = 'true';

        this.initialized = true; // Mark as initialized
        this.setup();
        this.editableInitialEditing();
        this.addHeaderListeners();
    }
}

registerComponent(`.${componentName}`, PlexFooter);
